import React from 'react';

const SubscriptionCodesContext = React.createContext();

const SubscriptionCodesProvider = (props) => {
  return (
    <SubscriptionCodesContext.Provider value={props.value}>
      {props.children}
    </SubscriptionCodesContext.Provider>
  );
};

export { SubscriptionCodesContext, SubscriptionCodesProvider}
